import { createListViewContainer } from 'factories/ListView'
import selectors from 'selectors'
import actions from 'actions/tasks'
import Component from 'components/JobSchedule'

export default createListViewContainer({ actions, selectors: selectors.tasks })(Component)
